import api from './client';

export const notificationAPI = {
  getAllNotifications: async (options = {}) => {
    const response = await api.get("/notifications", {
      params: {
        page: options.page,
        per_page: options.per_page,
        sort_field: options.sort_field,
        sort_direction: options.sort_direction,
        type: options.type,
        is_read: options.is_read,
        search: options.search,
      },
    });
    return response.data;
  },

  getNotificationById: async (id) => {
    const response = await api.get(`/notifications/${id}`);
    return response.data;
  },

  createNotification: async (notificationData) => {
    const response = await api.post("/notifications", notificationData);
    return response.data;
  },

  updateNotification: async (id, notificationData) => {
    const response = await api.put(`/notifications/${id}`, notificationData);
    return response.data;
  },

  deleteNotification: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },

  markAsRead: async (id) => {
    const response = await api.patch(`/notifications/${id}/read`);
    return response.data;
  },

  getUnreadNotifications: async () => {
    const response = await api.get("/notifications/unread");
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await api.patch("/notifications/read-all");
    return response.data;
  },

  getUnreadCount: async () => {
    const response = await api.get("/notifications/unread-count");
    return response.data;
  },

  sendToMultiple: async (data) => {
    const response = await api.post("/notifications/send-to-multiple", data);
    return response.data;
  },

  clearAll: async () => {
    const response = await api.delete("/notifications/clear-all");
    return response.data;
  },
};

// Audit API

export const arrivalNotificationAPI = {
  // Get all notifications with optional filtering
  getAll: async (params = {}) => {
    const response = await api.get("/arrival-notifications", { params });
    return response.data;
  },

  // Get single notification by ID
  getById: async (id) => {
    const response = await api.get(`/arrival-notifications/${id}`);
    return response.data;
  },

  // Create new notification (draft)
  create: async (data) => {
    const response = await api.post("/arrival-notifications", data);
    return response.data;
  },

  // Update notification (draft only)
  update: async (id, data) => {
    const response = await api.put(`/arrival-notifications/${id}`, data);
    return response.data;
  },

  // Delete notification (draft only)
  delete: async (id) => {
    const response = await api.delete(`/arrival-notifications/${id}`);
    return response.data;
  },

  // Send notification email
  // Optionally pass email to override SKIM database email
  send: async (id, email = null) => {
    const data = email ? { email } : {};
    const response = await api.post(`/arrival-notifications/${id}/send`, data);
    return response.data;
  },

  // Get summary report
  getSummary: async (params = {}) => {
    const response = await api.get("/arrival-notifications/summary", { params });
    return response.data;
  },

  // Get fixed attachments
  getAttachments: async () => {
    const response = await api.get("/arrival-notifications/attachments");
    return response.data;
  },

  // Upload fixed attachment
  uploadAttachment: async (formData) => {
    const response = await api.post("/arrival-notifications/attachments", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // Update worker remarks (post-arrival action tracking)
  // workers: [{ applicationWorkerId: number, remarks: string | null }]
  updateWorkerRemarks: async (workers) => {
    const response = await api.patch("/arrival-notifications/update-remarks", { workers });
    return response.data;
  },
};
